﻿import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService, PortalService, ElectronIPC } from '../_services/index';

@Component({
    moduleId: module.id,
    templateUrl: 'wizardRegister.component.html'
})

export class WizardRegister {
    model: any = {};
    loading = false;

    constructor(
        private router: Router,
        private portalService: PortalService,
        private alertService: AlertService,
        private ipc: ElectronIPC) { }

    register() {
        this.loading = true;
        this.model.realCustomerInfo = "Company: " + encodeURIComponent(this.model.company);
        if (this.model.customerInfo != undefined) {
            this.model.realCustomerInfo += encodeURIComponent("\nUser provided ID to portal: " + this.model.customerInfo);
        }
        this.model.customerInfo = this.model.realCustomerInfo;
        console.log("creating user %o", this.model);
        this.portalService.createPortalUserAccount(this.model)
            .subscribe(
                data => {
                    console.log("RegisterComponent:register() got data = %o", data);
                    if ( data ) {
                        this.router.navigate(['/wizard/wizardAwaitActivation'],
                            { queryParams: {username: this.model.emailaddress}});
                        this.alertService.success('Sign Up Completed.', true);
                    }
                },
                error => {
                    this.loading = false;

                    if ( error.toString().includes("portal.account.exists.no.password")) {
                        this.alertService.error("The e-mail address '" + this.model.emailaddress + "' is already registered, but does not have a password set. Please set your password.", true);
                        this.router.navigate(['/wizard/wizardForgotPassword/' + this.model.emailaddress]);
                    } else if ( error.toString().includes("portal.account.exists") ) {
                        this.alertService.error("The e-mail address '"+ this.model.emailaddress + "' is already registered.  Please sign-in using '" + this.model.emailaddress + "'.", true);
                        this.router.navigate(['/wizard/wizardLogin']);
                    } else {
                        this.alertService.error(error);
                    }
                });
    }

	goback() {
		this.portalService.logout();
		this.router.navigate(['/wizard/wizardLogin']);
	}

	closeapp() {
		this.portalService.logout();
		this.ipc.send('closeApp');
	}
}
